import {InputTypes} from "../InputTypes";

/**
 * Describes which fields of a Video backend object are visible in the  UI 
 * visible and how they should be rendered/modified in the front
 */
export const Video = Object.freeze({
    name: {
        visibleName: "Título",
        type: InputTypes.TEXT
    },
    visible_timestamp:{
        visibleName: "Visible Desde",
        type: InputTypes.DATE,
    },
    // timestamp:{
    //     visibleName: "Fecha de Creación",
    //     type: InputTypes.DATE,
    //     readOnly: true
    // },
    text:{
        visibleName: "Descripción",
        type: InputTypes.RICH_TEXT_AREA
    },
    media:{
        visibleName: "Media",
        type: InputTypes.PREVIEW
    },
})